<h3>Select your user</h3>
<ul>
  <li *ngFor="let user of users">
    <button (click)="login(user.cfid)">LOGIN</button>
    <span> - </span>
    <span>{{user.name}}</span>
  </li>
</ul>
